export default __webpack_public_path__ + "static/media/up-arrow-black.28e486da.svg";